// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth} from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAce9swkvx5jfZgU7eiykx3wOBwOQwxErQ",
  authDomain: "farmlancer-admin.firebaseapp.com",
  projectId: "farmlancer-admin",
  storageBucket: "farmlancer-admin.appspot.com",
  messagingSenderId: "218629903794",
  appId: "1:218629903794:web:a5dd89d8fe55e9ddeb40ab",
  measurementId: "G-TPQMELNP78"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth=getAuth();
export default app;
